import * as styles from 'styles/atoms/inputs/Captcha.css'
import TextField, { TextFieldOwnProps } from 'components/atoms/inputs/TextField'

type CaptchaProps = TextFieldOwnProps & {
  label?: string
  image: string
  value: string
}

const Captcha = (props: CaptchaProps) => (
  <div className={ styles.root }>
    <img src={ `data:image/png;base64,${ props.image }` } className={ styles.image } />
    <TextField { ...props } type='text' />
  </div>
)

export default Captcha
